<% var dateFormat = I18n.moment_date_format + ", " + I18n.moment_time_format %>
<% var dateFormatWithYear = I18n.moment_date_format_with_year + ", " + I18n.moment_time_format %>
<label class="field-label"><%= I18n.visit.labels.slot %></label>
<div class="field-input datetime-select" data-appointment-booking-wizard-behaviour="show-appointment-slot-picker" data-analytics-element="booking-visit-slot-field" data-analytics-interaction="click" role="button" tabindex="0">
  <span class="field-input-icon"></span>
  <span class="field-input-text">
    <% if (ehr_appointment_slot_id) { %>
      <%= Sparkle.Utilities.appointmentDate(moment.parseZone(appointment_slot.start_time), AppointmentBooking.config.slot_show_year, dateFormat, dateFormatWithYear) %>
    <% } else { %>
      <%= I18n.prompts.slot %>
    <% } %>
  </span>
</div>
